import { escapeHtml } from "./escapeHtml";

/** Minimal Slack mrkdwn → HTML for recap display. Input must be escaped before tag insertion. */
export function slackMrkdwnToHtml(text: string): string {
	const safe = escapeHtml(text);
	return safe
		.replace(/\*([^*]+)\*/g, "<strong>$1</strong>")
		.replace(/_([^_]+)_/g, "<em>$1</em>")
		.replace(/\n/g, "<br />");
}
